























































import { AreaItem } from '@tt4b/ttam-enums';
import { computed, defineComponent, PropType, ref } from '@vue/composition-api';

const name = 'ttam-location';
export default defineComponent({
  name,
  components: {},
  props: {
    value: {
      type: Array as PropType<number[]>,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    treeData: {
      type: Array as PropType<AreaItem[]>,
      default: () => [],
    },
    treeProps: {
      type: Object,
      default: () => ({}),
    },
    resultListType: {
      type: String,
      default: 'auto-outside',
    },
    filterCheckStrictly: {
      type: Boolean,
      default: false,
    },
    filterMethod: {
      type: Function,
    },
    enableSelectOneNode: {
      type: Boolean,
      default: true,
    },
    noDataLabel: {
      type: String,
      default: '',
    },
    noDataBtn: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const selectTreeRef = ref();

    const _particleLocations = computed({
      get: () => props.value,
      set: val => {
        emit('input', val);
        emit('change', val);
      },
    });
    const onLocationChange = (val, nodes, node, isChecked) => {
      emit('location-change', val, nodes, node, isChecked);
    };
    const onClearAll = () => {
      emit('close-all');
    };

    const onSearchKeywordChange = val => {
      emit('filter-keyword-input', val);
    };

    const onLimitSelect = () => {
      emit('limit-select');
    };

    const onClickEmpty = () => {
      emit('on-click-empty');
      selectTreeRef.value?.closePopover?.();
    };

    return {
      name,
      selectTreeRef,
      _particleLocations,
      onLocationChange,
      onClearAll,
      onSearchKeywordChange,
      onLimitSelect,
      onClickEmpty,
    };
  },
});
